import React from 'react';
import classNames from 'classnames';
import { compose, render } from '@/utils/story-composer';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';
import { BorderColorEnum } from '@/enums/styling';

function TableColumn({ content, colSpan, pageContext }) {
	const { border = [], borderSize = '1px', borderColor = 'WHITE' } = pageContext;

	const hasBorderTop = border.includes('top');
	const hasBorderLeft = border.includes('left');
	const hasBorderRight = border.includes('right');
	const hasBorderBottom = border.includes('bottom');

	const borderClasses = {};

	borderClasses[`border-t-[${borderSize}]`] = hasBorderTop;
	borderClasses[`border-l-[${borderSize}]`] = hasBorderLeft;
	borderClasses[`border-r-[${borderSize}]`] = hasBorderRight;
	borderClasses[`border-b-[${borderSize}]`] = hasBorderBottom;

	const borderColorClass = getTailwindClassByEnum(BorderColorEnum, borderColor);

	return (
		<td
			colSpan={colSpan}
			className={classNames('p-2', borderColorClass, {
				...borderClasses,
			})}
		>
			{render(content)}
		</td>
	);
}

export default TableColumn;

compose('table-column', TableColumn);
